import { defineMessages } from 'react-intl';

const _default_1: {
	// Conversation starter labels
	readonly beProductiveLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.be-productive';
		readonly defaultMessage: 'Be productive';
		readonly description: 'Label for the "Be productive" conversation starter tile';
	};
	readonly stayUpToDateLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.stay-up-to-date';
		readonly defaultMessage: 'Stay up-to-date';
		readonly description: 'Label for the "Stay up-to-date" conversation starter tile';
	};
	readonly summarizeContentLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.summarize-content';
		readonly defaultMessage: 'Summarize content';
		readonly description: 'Label for the "Summarize content" conversation starter tile';
	};
	readonly rephraseContentLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.rephrase-content';
		readonly defaultMessage: 'Rephrase content';
		readonly description: 'Label for the "Rephrase content" conversation starter tile';
	};
	readonly draftContentLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.draft-content';
		readonly defaultMessage: 'Draft content';
		readonly description: 'Label for the "Draft content" conversation starter tile';
	};
	readonly findInformationLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.find-information';
		readonly defaultMessage: 'Find information';
		readonly description: 'Label for the "Find information" conversation starter tile';
	};
	readonly findPeopleLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.find-people';
		readonly defaultMessage: 'Find people';
		readonly description: 'Label for the "Find people" conversation starter tile';
	};
	readonly codeSearchLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.code-search';
		readonly defaultMessage: 'Code search';
		readonly description: 'Label for the "Code search" conversation starter tile';
	};
	readonly measureProductivityLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.measure-productivity';
		readonly defaultMessage: 'Measure productivity';
		readonly description: 'Label for the "Measure productivity" conversation starter tile';
	};
	readonly getAnswersLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.get-answers';
		readonly defaultMessage: 'Get answers';
		readonly description: 'Label for the "Get answers" conversation starter tile';
	};
	readonly checkStatusLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.check-status';
		readonly defaultMessage: 'Check status';
		readonly description: 'Label for the "Check status" conversation starter tile';
	};
	readonly summarizeInformationLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.summarize-information';
		readonly defaultMessage: 'Summarize information';
		readonly description: 'Label for the "Summarize information" conversation starter tile';
	};
	readonly analyzeContentLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.analyze-content';
		readonly defaultMessage: 'Analyze content';
		readonly description: 'Label for the "Analyze content" conversation starter tile';
	};
	readonly summarizeCodeLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.summarize-code';
		readonly defaultMessage: 'Summarize code';
		readonly description: 'Label for the "Summarize code" conversation starter tile';
	};
	readonly automationRuleLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.automation-rule';
		readonly defaultMessage: 'Automation rule';
		readonly description: 'Label for the "Automation rule" conversation starter tile';
	};
	readonly manageSettingsLabel: {
		readonly id: 'rovo-conversation-actions.conversation-starters.label.manage-settings';
		readonly defaultMessage: 'Manage settings';
		readonly description: 'Label for the "Manage settings" conversation starter tile';
	};
	// BITBUCKET_CREATE_PULL_REQUESTS
	readonly bitbucketCreatePullRequestsPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1';
		readonly defaultMessage: 'Suggest reviewers for this pull request';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Create Pull Requests';
	};
	// BITBUCKET_PULL_REQUESTS
	readonly bitbucketPullRequestsPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1';
		readonly defaultMessage: 'Summarize this pull request';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	readonly bitbucketPullRequestsPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2';
		readonly defaultMessage: 'Explain the code changes to me.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	readonly bitbucketPullRequestsPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3';
		readonly defaultMessage: 'Summarize the comments on this pull request';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	readonly bitbucketPullRequestsPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4';
		readonly defaultMessage: 'Explain the code changes';
		readonly description: 'The forth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	readonly bitbucketPullRequestsPrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1';
		readonly defaultMessage: 'Summarize the build logs';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	readonly bitbucketPullRequestsPrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6';
		readonly defaultMessage: 'Suggest reviewers for this pull request';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests';
	};
	// BITBUCKET_REPOSITORY_SOURCE
	readonly bitbucketRepositorySourcePrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1';
		readonly defaultMessage: 'Explain this file';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket Repository Source';
	};
	readonly bitbucketRepositorySourcePrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2';
		readonly defaultMessage: 'What are the pull requests authored by `person`?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket Repository Source';
	};
	readonly bitbucketRepositorySourcePrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3';
		readonly defaultMessage: ' What APIs or modules do these files interact with?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing Bitbucket Repository Source';
	};
	readonly bitbucketRepositorySourcePrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4';
		readonly defaultMessage: 'Find pull requests authored by `person`';
		readonly description: 'The forth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source';
	};
	readonly bitbucketRepositorySourcePrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5';
		readonly defaultMessage: 'Find APIs that these files interact with';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source';
	};
	// BITBUCKET_PIPELINES
	readonly bitbucketPipelinePrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1';
		readonly defaultMessage: 'Summarize the build logs';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Bitbucket pipelines';
	};
	readonly bitbucketPipelinePrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2';
		readonly defaultMessage: 'What is the status of the `build`?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Bitbucket pipelines';
	};
	// BITBUCKET_HOME
	readonly bitbucketPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-1';
		readonly defaultMessage: 'What are the pull requests authored by `person`?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-2';
		readonly defaultMessage: 'What are the open PRs for the current Jira sprint?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-3';
		readonly defaultMessage: 'Has `Jira work item` been deployed?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-4';
		readonly defaultMessage: 'Who are the reviewers on this `Pull request`?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-5';
		readonly defaultMessage: 'Find pull requests authored by `person`';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-6';
		readonly defaultMessage: 'Check deployment status of `Jira work item`';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	readonly bitbucketPrompt7: {
		readonly id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-7';
		readonly defaultMessage: 'Find reviewers of `pull request`';
		readonly description: 'The seventh prompt option in the empty state of the chat history when viewing any page on Bitbucket';
	};
	// CONFLUENCE_HOME
	readonly confluenceHomePrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-1';
		readonly defaultMessage: "Is there any new activity on pages I've written?";
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Confluence Home';
	};
	readonly confluenceHomePrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-2';
		readonly defaultMessage: 'Are there any new comments mentioning me?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Confluence Home';
	};
	readonly confluenceHomePrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-3';
		readonly defaultMessage: 'Summarize the most recently published pages in this space.';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing Confluence Home';
	};
	readonly confluenceHomePrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-4';
		readonly defaultMessage: 'Summarize my contributions to pages from last week.';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-5';
		readonly defaultMessage: 'Can you take this `page` and write it in a less technical way?';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-6';
		readonly defaultMessage: 'Create a game plan template for project management.';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt7: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-7';
		readonly defaultMessage: 'What research do we have on common customer problems?';
		readonly description: 'The seventh prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt8: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-8';
		readonly defaultMessage: 'Has anyone on my team published any new pages this week?';
		readonly description: 'The eighth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt9: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-9';
		readonly defaultMessage: 'Has `person` published any new pages this week?';
		readonly description: 'The ninth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt10: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-10';
		readonly defaultMessage: "Has `person` commented on any pages that I've published?";
		readonly description: 'The tenth prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt11: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-11';
		readonly defaultMessage: 'What are the key takeaways from `page`?';
		readonly description: 'The eleventh prompt option in the empty state of the chat history when viewing Confluence';
	};
	readonly confluenceHomePrompt12: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-12';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The twelfth prompt option in the empty state of the chat history when viewing Confluence';
	};
	// CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
	readonly confluencePageViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1';
		readonly defaultMessage: "Summarize what I'm looking at.";
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	readonly confluencePageViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2';
		readonly defaultMessage: 'Summarize the comments on this page.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	readonly confluencePageViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3';
		readonly defaultMessage: "Explain this page to me like I'm a beginner.";
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	readonly confluencePageViewPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4';
		readonly defaultMessage: 'Who wrote this page and what team are they on?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	readonly confluencePageViewPrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5';
		readonly defaultMessage: 'Has anything on this page changed in the last week?';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	readonly confluencePageViewPrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing a Confluence page';
	};
	// CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
	readonly confluencePageEditPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1';
		readonly defaultMessage: 'Can you improve the writing on this page?';
		readonly description: 'The first prompt option in the empty state of the chat history when editing a Confluence page';
	};
	readonly confluencePageEditPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2';
		readonly defaultMessage: 'Write an executive summary for this page.';
		readonly description: 'The second prompt option in the empty state of the chat history when editing a Confluence page';
	};
	readonly confluencePageEditPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3';
		readonly defaultMessage: 'Give me links to some other relevant pages.';
		readonly description: 'The third prompt option in the empty state of the chat history when editing a Confluence page';
	};
	readonly confluencePageEditPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when editing a Confluence page';
	};
	// CONFLUENCE_WHITEBOARD
	readonly confluenceWhiteboardPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1';
		readonly defaultMessage: "Summarize what I'm looking at.";
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Confluence whiteboard';
	};
	readonly confluenceWhiteboardPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2';
		readonly defaultMessage: 'Highlight any patterns or trends visible here.';
		readonly description: 'The second prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.';
	};
	readonly confluenceWhiteboardPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3';
		readonly defaultMessage: 'Identify any key action items or decisions captured in this whiteboard.';
		readonly description: 'The third prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.';
	};
	readonly confluenceWhiteboardPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing a Confluence whiteboard';
	};
	// JIRA_HOME
	readonly jiraHomePrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-1';
		readonly defaultMessage: 'Find Jira issues that have been updated this week.';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Jira Home';
	};
	readonly jiraHomePrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-2';
		readonly defaultMessage: 'What Jira issues are the highest priority?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Jira Home';
	};
	readonly jiraHomePrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-3';
		readonly defaultMessage: 'What Jira issues have comments mentioning me?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing Jira Home';
	};
	readonly jiraHomePrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-4';
		readonly defaultMessage: 'Summarize the comments on `Jira issue`.';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing Jira Home';
	};
	readonly jiraHomePrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-5';
		readonly defaultMessage: 'Create a description template for user stories.';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing Jira Home';
	};
	readonly jiraHomePrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-6';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing Jira Home';
	};
	// JIRA_ISSUE_VIEW
	readonly jiraIssueViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1';
		readonly defaultMessage: 'Are there any similar Jira issues to this one?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Jira issue';
	};
	readonly jiraIssueViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2';
		readonly defaultMessage: 'How could I improve the description?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Jira issue';
	};
	readonly jiraIssueViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3';
		readonly defaultMessage: 'What labels could I add to this issue?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Jira issue';
	};
	readonly jiraIssueViewPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira issue';
	};
	// JIRA_PROJECT
	readonly jiraProjectPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-1';
		readonly defaultMessage: 'What work hasn’t been picked up in a while?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-2';
		readonly defaultMessage: 'Are any Jira issues blocked?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-3';
		readonly defaultMessage: 'List Jira issues that are currently “In Progress” and group them by assignee.';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-4';
		readonly defaultMessage: 'How many issues are assigned to `person`?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-5';
		readonly defaultMessage: 'Has `person` commented on any Jira issues in this sprint?';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-6';
		readonly defaultMessage: 'What Jira issues are unassigned?';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt7: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-7';
		readonly defaultMessage: 'What Jira issues have been open the longest?';
		readonly description: 'The seventh prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt8: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-8';
		readonly defaultMessage: 'Who has the most tasks?';
		readonly description: 'The eighth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt9: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-9';
		readonly defaultMessage: 'Find and group similar Jira issues.';
		readonly description: 'The ninth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt10: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-10';
		readonly defaultMessage: 'Are there any Jira issues not connected to a parent issue?';
		readonly description: 'The tenth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt11: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-11';
		readonly defaultMessage: 'Take `Jira issue` description and align it to best-practice.';
		readonly description: 'The eleventh prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt12: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-12';
		readonly defaultMessage: 'Summarize the comments on `Jira issue`.';
		readonly description: 'The twelfth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt13: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-13';
		readonly defaultMessage: 'Create a description template for user stories.';
		readonly description: 'The thirteenth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	readonly jiraProjectPrompt14: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-14';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The fourteenth prompt option in the empty state of the chat history when viewing a Jira project';
	};
	// JIRA_BOARD
	readonly jiraBoardPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-2';
		readonly defaultMessage: 'How many work items are unassigned for this board?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-3';
		readonly defaultMessage: 'Which work items are stale for this board?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-4';
		readonly defaultMessage: 'Which work items are blocked for this board?';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-6';
		readonly defaultMessage: 'Summarize this board for me.';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt7: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-7';
		readonly defaultMessage: 'Update work items for this board.';
		readonly description: 'The seventh prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt8: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-8';
		readonly defaultMessage: 'Move work items to a status for this board.';
		readonly description: 'The eighth prompt option in the empty state of the chat history when viewing a Jira board';
	};
	readonly jiraBoardPrompt9: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-9';
		readonly defaultMessage: 'Assign or reassign work items for this board.';
		readonly description: 'The ninth prompt option in the empty state of the chat history when viewing a Jira board';
	};
	// JSM_INCIDENT_VIEW
	readonly jsmIncidentViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1';
		readonly defaultMessage: 'Find people who can help resolve this incident';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a JSM incident';
	};
	readonly jsmIncidentViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2';
		readonly defaultMessage: 'Are there any ongoing incidents?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a JSM incident';
	};
	readonly jsmIncidentViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3';
		readonly defaultMessage: 'Create a post-incident review (PIR)';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a JSM incident';
	};
	// JSM_INCIDENT_LIST_VIEW
	readonly jsmIncidentListViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1';
		readonly defaultMessage: 'Are there any ongoing incidents?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing JSM incident list';
	};
	readonly jsmIncidentListViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2';
		readonly defaultMessage: 'Get me the open high priority incidents';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing JSM incident list';
	};
	readonly jsmIncidentListViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3';
		readonly defaultMessage: 'Are there any open alerts?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing JSM incident list';
	};
	// JSM_ALERT_VIEW (Alert details page)
	readonly jsmAlertViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1';
		readonly defaultMessage: 'Find open alerts';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing JSM alert details';
	};
	readonly jsmAlertViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2';
		readonly defaultMessage: 'Investigate this alert';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing JSM alert details';
	};
	readonly jsmAlertViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3';
		readonly defaultMessage: 'Are there any ongoing incidents?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing JSM alert details';
	};
	// JSM_ALERT_LIST_VIEW (Alert list page)
	readonly jsmAlertListViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1';
		readonly defaultMessage: 'Find open alerts';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing JSM alert list';
	};
	readonly jsmAlertListViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2';
		readonly defaultMessage: 'Find recently closed alerts';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing JSM alert list';
	};
	readonly jsmAlertListViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3';
		readonly defaultMessage: 'Are there any ongoing incidents?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing JSM alert list';
	};
	// JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
	readonly jsmAlertGroupDetailViewPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1';
		readonly defaultMessage: 'Find open alerts';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing JSM alert group details';
	};
	readonly jsmAlertGroupDetailViewPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2';
		readonly defaultMessage: 'Find recently closed alerts';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing JSM alert group details';
	};
	readonly jsmAlertGroupDetailViewPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3';
		readonly defaultMessage: 'Are there any ongoing incidents?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing JSM alert group details';
	};
	// ATLAS HOME
	readonly atlasHomePrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-1';
		readonly defaultMessage: 'What Confluence pages have I contributed to recently?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-2';
		readonly defaultMessage: 'Find all Jira tickets that are assigned to me.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-3';
		readonly defaultMessage: 'What is our travel policy?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt4: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-4';
		readonly defaultMessage: 'Draft a Confluence page for a marketing campaign.';
		readonly description: 'The fourth prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt5: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-5';
		readonly defaultMessage: 'How can I create a project timeline?';
		readonly description: 'The fifth prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt6: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-6';
		readonly defaultMessage: 'Write a follow up email to potential clients.';
		readonly description: 'The sixth prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	readonly atlasHomePrompt7: {
		readonly id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-7';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The seventh prompt option in the empty state of the chat history when viewing Atlas Home';
	};
	// FOCUS
	readonly focusPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus.starter-1';
		readonly defaultMessage: 'Summarize my focus areas.';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing Focus';
	};
	readonly focusPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus.starter-2';
		readonly defaultMessage: 'Identify gaps and highlight risks.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing Focus';
	};
	// FOCUS_FOCUS_AREA_PAGE
	readonly focusAreaPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus-area.starter-1';
		readonly defaultMessage: 'Summarize this focus area.';
		readonly description: 'The first prompt option when viewing a specific focus area page in Focus';
	};
	// FOCUS_FOCUS_AREA_GOAL_VIEW
	readonly focusAreaGoalPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1';
		readonly defaultMessage: 'Summarize the goals linked to this focus area.';
		readonly description: 'The first prompt option when viewing the goal view of a specific focus area in Focus';
	};
	// FOCUS_FOCUS_AREA_WORK_VIEW
	readonly focusAreaWorkPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus-area-work.starter-1';
		readonly defaultMessage: 'Summarize the work linked to this focus area.';
		readonly description: 'The first prompt option when viewing the work view of a specific focus area in Focus';
	};
	// FOCUS_FOCUS_AREA_FUNDS_VIEW
	readonly focusAreaFundsPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1';
		readonly defaultMessage: 'Analyze the funds linked to this focus area.';
		readonly description: 'The first prompt option when viewing the funds view of a specific focus area in Focus';
	};
	// FOCUS_FOR_YOU
	readonly focusForYouPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.focus-for-you.starter-1';
		readonly defaultMessage: 'Summarize my focus areas.';
		readonly description: 'The first prompt option when viewing For You page in Focus';
	};
	// SAC
	readonly sacPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.sac.starter-1';
		readonly defaultMessage: 'How do I manage settings?';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing SAC';
	};
	readonly sacPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.sac.starter-2';
		readonly defaultMessage: 'How do I find information?';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing SAC';
	};
	readonly sacPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.sac.starter-3';
		readonly defaultMessage: 'How do I create an automation rule?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing SAC';
	};
	// TRELLO_BOARD (board/universal rovo button)
	readonly trelloBoardPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-1';
		readonly defaultMessage: 'Summarize this board.';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Trello board';
	};
	readonly trelloBoardPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-2';
		readonly defaultMessage: 'Suggest ways to organize this board.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Trello board';
	};
	readonly trelloBoardPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-3';
		readonly defaultMessage: 'What should my top 3 priorities be today?';
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Trello board';
	};
	// TRELLO_CARD (cardback)
	readonly trelloCardPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-1';
		readonly defaultMessage: 'Summarize this card.';
		readonly description: 'The first prompt option in the empty state of the chat history when viewing a Trello card';
	};
	readonly trelloCardPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-2';
		readonly defaultMessage: 'Find work related to this card.';
		readonly description: 'The second prompt option in the empty state of the chat history when viewing a Trello card';
	};
	readonly trelloCardPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-3';
		readonly defaultMessage: "Suggest improvements for this card's description.";
		readonly description: 'The third prompt option in the empty state of the chat history when viewing a Trello card';
	};
	// UNKNOWN
	readonly unknownPrompt1: {
		readonly id: 'rovo-conversation-actions.conversation-starters.unknown.starter-1';
		readonly defaultMessage: 'Are any of my work items overdue?';
		readonly description: 'The first suggestion displayed in the empty state of the chat history';
	};
	readonly unknownPrompt2: {
		readonly id: 'rovo-conversation-actions.conversation-starters.unknown.starter-2';
		readonly defaultMessage: 'What should I work on next?';
		readonly description: 'The second suggestion displayed in the empty state of the chat history';
	};
	readonly unknownPrompt3: {
		readonly id: 'rovo-conversation-actions.conversation-starters.unknown.starter-3';
		readonly defaultMessage: 'Write an update about my week.';
		readonly description: 'The third suggestion displayed in the empty state of the chat history';
	};
} = defineMessages({
	// Conversation starter labels
	beProductiveLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.be-productive',
		defaultMessage: 'Be productive',
		description: 'Label for the "Be productive" conversation starter tile',
	},
	stayUpToDateLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.stay-up-to-date',
		defaultMessage: 'Stay up-to-date',
		description: 'Label for the "Stay up-to-date" conversation starter tile',
	},
	summarizeContentLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.summarize-content',
		defaultMessage: 'Summarize content',
		description: 'Label for the "Summarize content" conversation starter tile',
	},
	rephraseContentLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.rephrase-content',
		defaultMessage: 'Rephrase content',
		description: 'Label for the "Rephrase content" conversation starter tile',
	},
	draftContentLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.draft-content',
		defaultMessage: 'Draft content',
		description: 'Label for the "Draft content" conversation starter tile',
	},
	findInformationLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.find-information',
		defaultMessage: 'Find information',
		description: 'Label for the "Find information" conversation starter tile',
	},
	findPeopleLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.find-people',
		defaultMessage: 'Find people',
		description: 'Label for the "Find people" conversation starter tile',
	},
	codeSearchLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.code-search',
		defaultMessage: 'Code search',
		description: 'Label for the "Code search" conversation starter tile',
	},
	measureProductivityLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.measure-productivity',
		defaultMessage: 'Measure productivity',
		description: 'Label for the "Measure productivity" conversation starter tile',
	},
	getAnswersLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.get-answers',
		defaultMessage: 'Get answers',
		description: 'Label for the "Get answers" conversation starter tile',
	},
	checkStatusLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.check-status',
		defaultMessage: 'Check status',
		description: 'Label for the "Check status" conversation starter tile',
	},
	summarizeInformationLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.summarize-information',
		defaultMessage: 'Summarize information',
		description: 'Label for the "Summarize information" conversation starter tile',
	},
	analyzeContentLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.analyze-content',
		defaultMessage: 'Analyze content',
		description: 'Label for the "Analyze content" conversation starter tile',
	},
	summarizeCodeLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.summarize-code',
		defaultMessage: 'Summarize code',
		description: 'Label for the "Summarize code" conversation starter tile',
	},
	automationRuleLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.automation-rule',
		defaultMessage: 'Automation rule',
		description: 'Label for the "Automation rule" conversation starter tile',
	},
	manageSettingsLabel: {
		id: 'rovo-conversation-actions.conversation-starters.label.manage-settings',
		defaultMessage: 'Manage settings',
		description: 'Label for the "Manage settings" conversation starter tile',
	},
	// BITBUCKET_CREATE_PULL_REQUESTS
	bitbucketCreatePullRequestsPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-create-pull-requests.starter-1',
		defaultMessage: 'Suggest reviewers for this pull request',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket Create Pull Requests',
	},
	// BITBUCKET_PULL_REQUESTS
	bitbucketPullRequestsPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-1',
		defaultMessage: 'Summarize this pull request',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-2',
		defaultMessage: 'Explain the code changes to me.',
		description:
			'The second prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-3',
		defaultMessage: 'Summarize the comments on this pull request',
		description:
			'The third prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-4',
		defaultMessage: 'Explain the code changes',
		description:
			'The forth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-5-1',
		defaultMessage: 'Summarize the build logs',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	bitbucketPullRequestsPrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pull-requests.starter-6',
		defaultMessage: 'Suggest reviewers for this pull request',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Bitbucket Pull Requests',
	},
	// BITBUCKET_REPOSITORY_SOURCE
	bitbucketRepositorySourcePrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-1',
		defaultMessage: 'Explain this file',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-2',
		defaultMessage: 'What are the pull requests authored by `person`?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-3',
		defaultMessage: ' What APIs or modules do these files interact with?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-4',
		defaultMessage: 'Find pull requests authored by `person`',
		description:
			'The forth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	bitbucketRepositorySourcePrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-repository-source.starter-5',
		defaultMessage: 'Find APIs that these files interact with',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Bitbucket Repository Source',
	},
	// BITBUCKET_PIPELINES
	bitbucketPipelinePrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-1-1',
		defaultMessage: 'Summarize the build logs',
		description:
			'The first prompt option in the empty state of the chat history when viewing Bitbucket pipelines',
	},
	bitbucketPipelinePrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket-pipelines.starter-2',
		defaultMessage: 'What is the status of the `build`?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Bitbucket pipelines',
	},
	// BITBUCKET_HOME
	bitbucketPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-1',
		defaultMessage: 'What are the pull requests authored by `person`?',
		description:
			'The first prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-2',
		defaultMessage: 'What are the open PRs for the current Jira sprint?',
		description:
			'The second prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-3',
		defaultMessage: 'Has `Jira work item` been deployed?',
		description:
			'The third prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-4',
		defaultMessage: 'Who are the reviewers on this `Pull request`?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-5',
		defaultMessage: 'Find pull requests authored by `person`',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-6',
		defaultMessage: 'Check deployment status of `Jira work item`',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},
	bitbucketPrompt7: {
		id: 'rovo-conversation-actions.conversation-starters.bitbucket.starter-7',
		defaultMessage: 'Find reviewers of `pull request`',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing any page on Bitbucket',
	},

	// CONFLUENCE_HOME
	confluenceHomePrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-1',
		defaultMessage: "Is there any new activity on pages I've written?",
		description:
			'The first prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-2',
		defaultMessage: 'Are there any new comments mentioning me?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-3',
		defaultMessage: 'Summarize the most recently published pages in this space.',
		description:
			'The third prompt option in the empty state of the chat history when viewing Confluence Home',
	},
	confluenceHomePrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-4',
		defaultMessage: 'Summarize my contributions to pages from last week.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-5',
		defaultMessage: 'Can you take this `page` and write it in a less technical way?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-6',
		defaultMessage: 'Create a game plan template for project management.',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt7: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-7',
		defaultMessage: 'What research do we have on common customer problems?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt8: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-8',
		defaultMessage: 'Has anyone on my team published any new pages this week?',
		description:
			'The eighth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt9: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-9',
		defaultMessage: 'Has `person` published any new pages this week?',
		description:
			'The ninth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt10: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-10',
		defaultMessage: "Has `person` commented on any pages that I've published?",
		description:
			'The tenth prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt11: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-11',
		defaultMessage: 'What are the key takeaways from `page`?',
		description:
			'The eleventh prompt option in the empty state of the chat history when viewing Confluence',
	},
	confluenceHomePrompt12: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-home.starter-12',
		defaultMessage: 'What should I work on next?',
		description:
			'The twelfth prompt option in the empty state of the chat history when viewing Confluence',
	},

	// CONFLUENCE_PAGE_VIEW & CONFLUENCE_BLOG_VIEW
	confluencePageViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-1',
		defaultMessage: "Summarize what I'm looking at.",
		description:
			'The first prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-2',
		defaultMessage: 'Summarize the comments on this page.',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-3',
		defaultMessage: "Explain this page to me like I'm a beginner.",
		description:
			'The third prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-4',
		defaultMessage: 'Who wrote this page and what team are they on?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-5',
		defaultMessage: 'Has anything on this page changed in the last week?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing a Confluence page',
	},
	confluencePageViewPrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-view.starter-6',
		defaultMessage: 'What should I work on next?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing a Confluence page',
	},

	// CONFLUENCE_PAGE_EDIT & CONFLUENCE_BLOG_EDIT
	confluencePageEditPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-1',
		defaultMessage: 'Can you improve the writing on this page?',
		description:
			'The first prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-2',
		defaultMessage: 'Write an executive summary for this page.',
		description:
			'The second prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-3',
		defaultMessage: 'Give me links to some other relevant pages.',
		description:
			'The third prompt option in the empty state of the chat history when editing a Confluence page',
	},
	confluencePageEditPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-page-edit.starter-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when editing a Confluence page',
	},

	// CONFLUENCE_WHITEBOARD
	confluenceWhiteboardPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-1',
		defaultMessage: "Summarize what I'm looking at.",
		description:
			'The first prompt option in the empty state of the chat history when viewing a Confluence whiteboard',
	},
	confluenceWhiteboardPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-2',
		defaultMessage: 'Highlight any patterns or trends visible here.',
		description:
			'The second prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.',
	},
	confluenceWhiteboardPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-3',
		defaultMessage: 'Identify any key action items or decisions captured in this whiteboard.',
		description:
			'The third prompt displayed in the empty state of the chat history when viewing a confluence whiteboard.',
	},
	confluenceWhiteboardPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.confluence-whiteboard.starter-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Confluence whiteboard',
	},

	// JIRA_HOME
	jiraHomePrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-1',
		defaultMessage: 'Find Jira issues that have been updated this week.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-2',
		defaultMessage: 'What Jira issues are the highest priority?',
		description:
			'The second prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-3',
		defaultMessage: 'What Jira issues have comments mentioning me?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-4',
		defaultMessage: 'Summarize the comments on `Jira issue`.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-5',
		defaultMessage: 'Create a description template for user stories.',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	jiraHomePrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.jira-home.starter-6',
		defaultMessage: 'What should I work on next?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Jira Home',
	},
	// JIRA_ISSUE_VIEW
	jiraIssueViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-1',
		defaultMessage: 'Are there any similar Jira issues to this one?',
		description:
			'The first prompt option in the empty state of the chat history when viewing a Jira issue',
	},
	jiraIssueViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-2',
		defaultMessage: 'How could I improve the description?',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Jira issue',
	},
	jiraIssueViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-3',
		defaultMessage: 'What labels could I add to this issue?',
		description:
			'The third prompt option in the empty state of the chat history when viewing a Jira issue',
	},
	jiraIssueViewPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.jira-issue-view.starter-4',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Jira issue',
	},

	// JIRA_PROJECT
	jiraProjectPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-1',
		defaultMessage: 'What work hasn’t been picked up in a while?',
		description:
			'The first prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-2',
		defaultMessage: 'Are any Jira issues blocked?',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-3',
		defaultMessage: 'List Jira issues that are currently “In Progress” and group them by assignee.',
		description:
			'The third prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-4',
		defaultMessage: 'How many issues are assigned to `person`?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-5',
		defaultMessage: 'Has `person` commented on any Jira issues in this sprint?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-6',
		defaultMessage: 'What Jira issues are unassigned?',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt7: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-7',
		defaultMessage: 'What Jira issues have been open the longest?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt8: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-8',
		defaultMessage: 'Who has the most tasks?',
		description:
			'The eighth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt9: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-9',
		defaultMessage: 'Find and group similar Jira issues.',
		description:
			'The ninth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt10: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-10',
		defaultMessage: 'Are there any Jira issues not connected to a parent issue?',
		description:
			'The tenth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt11: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-11',
		defaultMessage: 'Take `Jira issue` description and align it to best-practice.',
		description:
			'The eleventh prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt12: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-12',
		defaultMessage: 'Summarize the comments on `Jira issue`.',
		description:
			'The twelfth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt13: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-13',
		defaultMessage: 'Create a description template for user stories.',
		description:
			'The thirteenth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	jiraProjectPrompt14: {
		id: 'rovo-conversation-actions.conversation-starters.jira-project.starter-14',
		defaultMessage: 'What should I work on next?',
		description:
			'The fourteenth prompt option in the empty state of the chat history when viewing a Jira project',
	},
	// JIRA_BOARD
	jiraBoardPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-2',
		defaultMessage: 'How many work items are unassigned for this board?',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-3',
		defaultMessage: 'Which work items are stale for this board?',
		description:
			'The third prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-4',
		defaultMessage: 'Which work items are blocked for this board?',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-6',
		defaultMessage: 'Summarize this board for me.',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt7: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-7',
		defaultMessage: 'Update work items for this board.',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt8: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-8',
		defaultMessage: 'Move work items to a status for this board.',
		description:
			'The eighth prompt option in the empty state of the chat history when viewing a Jira board',
	},
	jiraBoardPrompt9: {
		id: 'rovo-conversation-actions.conversation-starters.jira-board.starter-9',
		defaultMessage: 'Assign or reassign work items for this board.',
		description:
			'The ninth prompt option in the empty state of the chat history when viewing a Jira board',
	},

	// JSM_INCIDENT_VIEW
	jsmIncidentViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-1',
		defaultMessage: 'Find people who can help resolve this incident',
		description:
			'The first prompt option in the empty state of the chat history when viewing a JSM incident',
	},
	jsmIncidentViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-2',
		defaultMessage: 'Are there any ongoing incidents?',
		description:
			'The second prompt option in the empty state of the chat history when viewing a JSM incident',
	},
	jsmIncidentViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-view.starter-3',
		defaultMessage: 'Create a post-incident review (PIR)',
		description:
			'The third prompt option in the empty state of the chat history when viewing a JSM incident',
	},

	// JSM_INCIDENT_LIST_VIEW
	jsmIncidentListViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-1',
		defaultMessage: 'Are there any ongoing incidents?',
		description:
			'The first prompt option in the empty state of the chat history when viewing JSM incident list',
	},
	jsmIncidentListViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-2',
		defaultMessage: 'Get me the open high priority incidents',
		description:
			'The second prompt option in the empty state of the chat history when viewing JSM incident list',
	},
	jsmIncidentListViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-incident-list-view.starter-3',
		defaultMessage: 'Are there any open alerts?',
		description:
			'The third prompt option in the empty state of the chat history when viewing JSM incident list',
	},

	// JSM_ALERT_VIEW (Alert details page)
	jsmAlertViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-1',
		defaultMessage: 'Find open alerts',
		description:
			'The first prompt option in the empty state of the chat history when viewing JSM alert details',
	},
	jsmAlertViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-2',
		defaultMessage: 'Investigate this alert',
		description:
			'The second prompt option in the empty state of the chat history when viewing JSM alert details',
	},
	jsmAlertViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-view.starter-3',
		defaultMessage: 'Are there any ongoing incidents?',
		description:
			'The third prompt option in the empty state of the chat history when viewing JSM alert details',
	},

	// JSM_ALERT_LIST_VIEW (Alert list page)
	jsmAlertListViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-1',
		defaultMessage: 'Find open alerts',
		description:
			'The first prompt option in the empty state of the chat history when viewing JSM alert list',
	},
	jsmAlertListViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-2',
		defaultMessage: 'Find recently closed alerts',
		description:
			'The second prompt option in the empty state of the chat history when viewing JSM alert list',
	},
	jsmAlertListViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-list-view.starter-3',
		defaultMessage: 'Are there any ongoing incidents?',
		description:
			'The third prompt option in the empty state of the chat history when viewing JSM alert list',
	},

	// JSM_ALERT_GROUP_DETAIL_VIEW (Alert group details page)
	jsmAlertGroupDetailViewPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-1',
		defaultMessage: 'Find open alerts',
		description:
			'The first prompt option in the empty state of the chat history when viewing JSM alert group details',
	},
	jsmAlertGroupDetailViewPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-2',
		defaultMessage: 'Find recently closed alerts',
		description:
			'The second prompt option in the empty state of the chat history when viewing JSM alert group details',
	},
	jsmAlertGroupDetailViewPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.jsm-alert-group-detail-view.starter-3',
		defaultMessage: 'Are there any ongoing incidents?',
		description:
			'The third prompt option in the empty state of the chat history when viewing JSM alert group details',
	},

	// ATLAS HOME
	atlasHomePrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-1',
		defaultMessage: 'What Confluence pages have I contributed to recently?',
		description:
			'The first prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-2',
		defaultMessage: 'Find all Jira tickets that are assigned to me.',
		description:
			'The second prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-3',
		defaultMessage: 'What is our travel policy?',
		description:
			'The third prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt4: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-4',
		defaultMessage: 'Draft a Confluence page for a marketing campaign.',
		description:
			'The fourth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt5: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-5',
		defaultMessage: 'How can I create a project timeline?',
		description:
			'The fifth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt6: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-6',
		defaultMessage: 'Write a follow up email to potential clients.',
		description:
			'The sixth prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	atlasHomePrompt7: {
		id: 'rovo-conversation-actions.conversation-starters.atlas-home.starter-7',
		defaultMessage: 'What should I work on next?',
		description:
			'The seventh prompt option in the empty state of the chat history when viewing Atlas Home',
	},
	// FOCUS
	focusPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus.starter-1',
		defaultMessage: 'Summarize my focus areas.',
		description:
			'The first prompt option in the empty state of the chat history when viewing Focus',
	},
	focusPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.focus.starter-2',
		defaultMessage: 'Identify gaps and highlight risks.',
		description:
			'The second prompt option in the empty state of the chat history when viewing Focus',
	},
	// FOCUS_FOCUS_AREA_PAGE
	focusAreaPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus-area.starter-1',
		defaultMessage: 'Summarize this focus area.',
		description: 'The first prompt option when viewing a specific focus area page in Focus',
	},
	// FOCUS_FOCUS_AREA_GOAL_VIEW
	focusAreaGoalPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus-area-goal.starter-1',
		defaultMessage: 'Summarize the goals linked to this focus area.',
		description:
			'The first prompt option when viewing the goal view of a specific focus area in Focus',
	},
	// FOCUS_FOCUS_AREA_WORK_VIEW
	focusAreaWorkPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus-area-work.starter-1',
		defaultMessage: 'Summarize the work linked to this focus area.',
		description:
			'The first prompt option when viewing the work view of a specific focus area in Focus',
	},
	// FOCUS_FOCUS_AREA_FUNDS_VIEW
	focusAreaFundsPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus-area-funds.starter-1',
		defaultMessage: 'Analyze the funds linked to this focus area.',
		description:
			'The first prompt option when viewing the funds view of a specific focus area in Focus',
	},
	// FOCUS_FOR_YOU
	focusForYouPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.focus-for-you.starter-1',
		defaultMessage: 'Summarize my focus areas.',
		description: 'The first prompt option when viewing For You page in Focus',
	},
	// SAC
	sacPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.sac.starter-1',
		defaultMessage: 'How do I manage settings?',
		description: 'The first prompt option in the empty state of the chat history when viewing SAC',
	},
	sacPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.sac.starter-2',
		defaultMessage: 'How do I find information?',
		description: 'The second prompt option in the empty state of the chat history when viewing SAC',
	},
	sacPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.sac.starter-3',
		defaultMessage: 'How do I create an automation rule?',
		description: 'The third prompt option in the empty state of the chat history when viewing SAC',
	},
	// TRELLO_BOARD (board/universal rovo button)
	trelloBoardPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-1',
		defaultMessage: 'Summarize this board.',
		description:
			'The first prompt option in the empty state of the chat history when viewing a Trello board',
	},
	trelloBoardPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-2',
		defaultMessage: 'Suggest ways to organize this board.',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Trello board',
	},
	trelloBoardPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.trello-board.starter-3',
		defaultMessage: 'What should my top 3 priorities be today?',
		description:
			'The third prompt option in the empty state of the chat history when viewing a Trello board',
	},
	// TRELLO_CARD (cardback)
	trelloCardPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-1',
		defaultMessage: 'Summarize this card.',
		description:
			'The first prompt option in the empty state of the chat history when viewing a Trello card',
	},
	trelloCardPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-2',
		defaultMessage: 'Find work related to this card.',
		description:
			'The second prompt option in the empty state of the chat history when viewing a Trello card',
	},
	trelloCardPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.trello-card.starter-3',
		defaultMessage: "Suggest improvements for this card's description.",
		description:
			'The third prompt option in the empty state of the chat history when viewing a Trello card',
	},
	// UNKNOWN
	unknownPrompt1: {
		id: 'rovo-conversation-actions.conversation-starters.unknown.starter-1',
		defaultMessage: 'Are any of my work items overdue?',
		description: 'The first suggestion displayed in the empty state of the chat history',
	},
	unknownPrompt2: {
		id: 'rovo-conversation-actions.conversation-starters.unknown.starter-2',
		defaultMessage: 'What should I work on next?',
		description: 'The second suggestion displayed in the empty state of the chat history',
	},
	unknownPrompt3: {
		id: 'rovo-conversation-actions.conversation-starters.unknown.starter-3',
		defaultMessage: 'Write an update about my week.',
		description: 'The third suggestion displayed in the empty state of the chat history',
	},
} as const);
export default _default_1;
